import {decorate, observable} from 'mobx';
import {faBalanceScaleLeft} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';

export class SensorData extends BaseModel {
  static faIcon = faBalanceScaleLeft;

  populateAttributesFromStore(rootStore) {
    this.workplace = rootStore.workplaceStore.getById(this.workplaceId);
    this.order = rootStore.orderStore.getById(this.orderId);
    return super.populateAttributesFromStore(rootStore);
  }
}

decorate(SensorData, {
  id: observable,
  sensorName: observable,
  workplace: observable,
  workplaceId: observable,
  order: observable,
  orderId: observable,
  timestamp: observable,
  value: observable,
});
